<template>
    <section class="sp-cta-final">
        <div class="sp-container">
            <div class="sp-cta-final__caja sp-reveal">
                <!-- Orbes de luz decorativos -->
                <div class="sp-glow-orb sp-glow-orb--orange" style="top: -20%; right: -10%; width: 320px; height: 320px;"></div>
                <div class="sp-glow-orb sp-glow-orb--cyan" style="bottom: -20%; left: -10%; width: 280px; height: 280px;"></div>

                <div class="sp-cta-final__icono" aria-hidden="true">
                    <i class="pi pi-compass"></i>
                </div>

                <div class="sp-cta-final__texto">
                    <h2>¿Listo para poner tu negocio en la ruta de miles de conductores?</h2>
                    <p>Crea tu cuenta de anunciante hoy mismo y comienza a recibir visitas en tu sede.</p>
                </div>

                <button type="button" class="sp-btn sp-btn--primary sp-cta-final__btn" @click="$emit('anunciarme')">
                    <span>Crear cuenta de anunciante</span>
                    <i class="pi pi-arrow-right" aria-hidden="true"></i>
                </button>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'NegociosCtaFinal',
    emits: ['anunciarme']
};
</script>

<style lang="scss" scoped>
.sp-cta-final {
    padding: clamp(3rem, 6vw, 4.5rem) 0;
    background: var(--sp-surface-alt);
}

.sp-cta-final__caja {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.75rem;
    padding: clamp(2.25rem, 5vw, 3.5rem);
    background: linear-gradient(135deg, #0d3044 0%, #081f2d 100%);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: var(--sp-radius-lg);
    box-shadow: 0 20px 60px rgba(8, 31, 45, 0.35);
    text-align: center;
}

.sp-cta-final__icono {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    width: 4.5rem;
    height: 4.5rem;
    border: 2px solid var(--sp-orange);
    border-radius: 50%;
    background: rgba(235, 93, 27, 0.15);
    color: var(--sp-orange);
    font-size: 1.8rem;
    box-shadow: 0 0 25px rgba(235, 93, 27, 0.3);
}

.sp-cta-final__texto {
    h2 {
        color: #ffffff;
        font-size: clamp(1.4rem, 2.8vw, 2.1rem);
        letter-spacing: -0.02em;
    }

    p {
        margin-top: 0.65rem;
        color: var(--sp-text-on-dark-soft);
        font-size: clamp(0.96rem, 1.4vw, 1.12rem);
        line-height: 1.6;
    }
}

.sp-cta-final__btn {
    flex: 0 0 auto;
    min-height: 52px;
    padding: 0.85rem 2rem;
    font-size: 1.05rem;
}

@media (min-width: 992px) {
    .sp-cta-final__caja {
        flex-direction: row;
        gap: 2.5rem;
        text-align: left;
    }

    .sp-cta-final__texto {
        flex: 1 1 auto;
    }
}
</style>
